'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCollectionProducts = exports.getProductByUrlCustomJSON = exports.getProductByUrl = exports.getProductListCustomJSON = exports.getProductList = exports.getProductByHandleCustomJSON = exports.getProductByHandle = exports.getProductHandleFromURL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var SHOPIFY_PRODUCT_URL_HANDLE_REGEX = /\/products\/(.[\w\d-+]+)/;

/**
 * Extracts product handle from the product URL
 *
 * @param {String} url - The URL of the Product Page
 * @returns {String} - The product handle
 */
var getProductHandleFromURL = exports.getProductHandleFromURL = function getProductHandleFromURL(url) {
  var matches = SHOPIFY_PRODUCT_URL_HANDLE_REGEX.exec(url);
  return matches && matches[1];
};

/**
 * Fetches product data from Shopify's AJAX API by handle
 *
 * @param {string} handle - The products handle
 *
 * @returns {Object} - The product object
 */
var getProductByHandle = exports.getProductByHandle = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(handle) {
    var _ref2, product;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _functional.fetchJSON)('/products/' + handle + '.json');

          case 2:
            _ref2 = _context.sent;
            product = _ref2.product;
            return _context.abrupt('return', product);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getProductByHandle(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Fetches product data from a custom endpoint that's set up as a liquid template
 *
 * @param {string} productHandle The products handle
 *
 * @returns {Object} The product object
 */
var getProductByHandleCustomJSON = exports.getProductByHandleCustomJSON = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(productHandle) {
    var response, data;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch('/products/' + productHandle + '?view=json');

          case 2:
            response = _context2.sent;
            _context2.next = 5;
            return response.text();

          case 5:
            data = _context2.sent;
            return _context2.abrupt('return', JSON.parse(data));

          case 7:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function getProductByHandleCustomJSON(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var getProductList = exports.getProductList = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(handleList) {
    var response;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _promise2.default.all(handleList.map(function () {
              var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(handle) {
                var res;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return getProductByHandle(handle);

                      case 2:
                        res = _context3.sent;
                        return _context3.abrupt('return', res);

                      case 4:
                      case 'end':
                        return _context3.stop();
                    }
                  }
                }, _callee3, undefined);
              }));

              return function (_x4) {
                return _ref5.apply(this, arguments);
              };
            }()));

          case 2:
            response = _context4.sent;
            return _context4.abrupt('return', response);

          case 4:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function getProductList(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

var getProductListCustomJSON = exports.getProductListCustomJSON = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(handleList) {
    var response;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _promise2.default.all(handleList.map(function () {
              var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(handle) {
                var res;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return getProductByHandleCustomJSON(handle);

                      case 2:
                        res = _context5.sent;
                        return _context5.abrupt('return', res);

                      case 4:
                      case 'end':
                        return _context5.stop();
                    }
                  }
                }, _callee5, undefined);
              }));

              return function (_x6) {
                return _ref7.apply(this, arguments);
              };
            }()));

          case 2:
            response = _context6.sent;
            return _context6.abrupt('return', response);

          case 4:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, undefined);
  }));

  return function getProductListCustomJSON(_x5) {
    return _ref6.apply(this, arguments);
  };
}();

var getProductByUrl = exports.getProductByUrl = function getProductByUrl(url) {
  var handle = getProductHandleFromURL(url);
  return fetch('/products/' + handle + '.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (resp) {
    return resp.json();
  });
};

var getProductByUrlCustomJSON = exports.getProductByUrlCustomJSON = function () {
  var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(url) {
    var handle, product;
    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            handle = SHOPIFY_PRODUCT_URL_HANDLE_REGEX.exec(url);
            _context7.next = 3;
            return getProductByHandleCustomJSON(handle[1]);

          case 3:
            product = _context7.sent;
            return _context7.abrupt('return', product);

          case 5:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, undefined);
  }));

  return function getProductByUrlCustomJSON(_x7) {
    return _ref8.apply(this, arguments);
  };
}();

/**
 * Fetches products that are contained inside a particular collection
 *
 * @param {string} collectionHandle - The collection handle
 * @param {number} [limit=1000] - Limits the amount of products returned
 *
 * @returns {Array} - A list of the products
 */
var getCollectionProducts = exports.getCollectionProducts = function () {
  var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(collectionHandle) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;

    var _ref10, products;

    return _regenerator2.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return (0, _functional.fetchJSON)('/collections/' + collectionHandle + '/products.json?limit=' + limit);

          case 2:
            _ref10 = _context8.sent;
            products = _ref10.products;
            return _context8.abrupt('return', products);

          case 5:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, undefined);
  }));

  return function getCollectionProducts(_x8) {
    return _ref9.apply(this, arguments);
  };
}();